import cn from 'classnames';
import React, { useMemo } from 'react';

import styles from './styles.module.scss';

interface ITableProps {
  className?: string;
}

export const Table: React.FC<ITableProps> = ({ className, children }) => (
  <table className={cn(styles.table, className)}>{children}</table>
);

interface ISectionProps extends React.HTMLProps<HTMLTableRowElement> {
  className?: string;
  inversion?: boolean;
}

export const Section: React.FC<ISectionProps> = ({ className, children, inversion }) => {
  const componentStyles = useMemo(
    () =>
      (inversion
        ? {
            '--even-color': 'var(--color-D06)',
            '--odd-color': 'var(--color-L100)',
          }
        : {
            '--even-color': 'var(--color-L100)',
            '--odd-color': 'var(--color-D06)',
          }) as React.CSSProperties,
    [inversion],
  );

  return (
    <tr className={cn(styles.section, className)} style={componentStyles}>
      {children}
    </tr>
  );
};

interface IColProps extends React.HTMLProps<HTMLTableDataCellElement> {
  className?: string;
  size?: number;
}

const Col: React.FC<IColProps> = ({ className, children, size, ...props }) => {
  const componentStyles = useMemo(
    () =>
      ({
        '--width': size ? `${(100 / 12) * size}%` : `${100 / 12}%`,
      } as React.CSSProperties),
    [size],
  );
  return (
    <td {...props} className={cn(styles.col, className)} style={componentStyles}>
      {children}
    </td>
  );
};

export const Content: React.FC<IColProps> = ({ className, ...props }) => (
  <Col className={cn(styles.content, className)} {...props} />
);

export const Title: React.FC<IColProps> = ({ className, ...props }) => (
  <Content className={cn(styles.title, className)} {...props} />
);
